import React from "react";
import { Modal } from "react-bootstrap";
import deleteImg from "../images/deleteIcon.png";

const ConfrimModal = (props) => {

  const {
    show,
    onHide,
    onYesClick,
    heading = "Delete User",
    message = "Are you sure you want to delete this User?",
  } = props;

  return (
    <div>
      <Modal
        show={show}
        onHide={() => onHide()}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="!p-0">
          <div className="w-full bg-white h-[321px] rounded-[5px] py-[40px] px-[50px] flex-col gap-[20px] justify-center items-center">
            <div className="w-full h-[182px] flex-col gap-[18px] justify-center items-center">
              <div className="flex justify-center">
                <img className="w-[116px] h-[116px]" src={deleteImg} alt="" />
              </div>
              <div className="font-[700] text-[25px] text-center text-[#FF7171]">
                {heading}
              </div>
              <div className="font-[500] text-[13.9px] text-center mt-[0.7rem]">
                {message}
              </div>
            </div>
            <div className="w-full h-[39px] flex gap-[12px] justify-center mt-4">
              <button
                className="rounded-[3px] p-[14px] flex items-center justify-center font-[700] bg-[#0000001A]"
                onClick={onHide}
              >
                No
              </button>
              <button
                className="rounded-[3px] p-[14px] flex items-center justify-center font-[700] text-[#FFFFFF]  bg-[#FF7171]"
                onClick={onYesClick}
              >
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfrimModal;
